import {
  adjustmentSessionIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { AdjustmentSessionSchema } from "./create-adjustment-session";

const AdjustmentSessionProductWithDetailsSchema_ = z.object({
  productId: productIdFormat.schema,
  title: z.string(),
  sku: z.string(),
  upc: z.string().nullable(),
  barcodes: z.array(z.string()),
  imageUrl: z.string().nullable(),
  currentQuantity: z.number(),
  quantity: z.number(),
  damagedQuantity: z.number().optional(),
  accountId: z.string().optional(),
  accountName: z.string().optional(),
});

export const AdjustmentSessionProductWithDetailsSchema: z.ZodType<AdjustmentSessionProductWithDetailsSchema> =
  AdjustmentSessionProductWithDetailsSchema_;
export interface AdjustmentSessionProductWithDetailsSchema
  extends z.infer<typeof AdjustmentSessionProductWithDetailsSchema_> {}

export const getAdjustmentSession = {
  name: "getAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({
    session: AdjustmentSessionSchema,
    products: z.array(AdjustmentSessionProductWithDetailsSchema),
  }),
};
